import StatisticsCampaign from 'modules/Statistics/Campaign/Campaign'
import Sagas from 'modules/Statistics/Campaign/saga'
import Reducer from 'modules/Statistics/Campaign/reducer'

export default StatisticsCampaign

export { Sagas, Reducer }
